module.exports = __webpack_public_path__ + "static/img/sxyffm.04b08ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sxyffm.jpg
// module id = 9z8T
// module chunks = 31